import { GONSCAN_TX_URL, GONSCAN_ADDRESS_URL } from "@/constants";

export function openInExplorer(hash: string) {
  window.open(GONSCAN_TX_URL + hash);
}

export function openAccountInExplorer(address: string) {
  window.open(GONSCAN_ADDRESS_URL + address);
}
